import Page from 'components/Page/Page'
import React from 'react'
import {Box, Typography, Button} from '@mui/material'
import {useNavigate} from 'react-router-dom'
import SearchOffRoundedIcon from '@mui/icons-material/SearchOffRounded'
import {useTranslation} from 'react-i18next'

const NotFound = () => {
    const navigate = useNavigate()
    const {t} = useTranslation()

    return (
        <Page>
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                height="100%"
                width="100%"
                gap={2}>
                <SearchOffRoundedIcon sx={{fontSize: 80, color: 'text.disabled'}} />
                <Typography variant="h1" fontWeight={700} color="text.disabled">
                    {t('notFound.title')}
                </Typography>
                <Typography variant="h5" fontWeight={500} color="text.secondary">
                    {t('notFound.subtitle')}
                </Typography>
                <Typography variant="body1" color="text.disabled" textAlign="center" maxWidth={360}>
                    {t('notFound.description')}
                </Typography>
                <Button variant="contained" sx={{mt: 2}} onClick={() => navigate('/dashboard')}>
                    {t('notFound.backToDashboard')}
                </Button>
            </Box>
        </Page>
    )
}

export default NotFound
